import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import * as PlanType from 'ecosystem-marketplace-core/constants/pricings/PlanType';
import ThemeQuery from '../../records/ThemeQuery';
import * as ThemeSort from '../../constants/ThemeSort';
import * as ThemeQueryField from '../../constants/ThemeQueryField';
import { isQa } from '../../utils/env';
const TOP = {
  description: 'There are thousands of themes, but these are the most downloaded. Try one of our most popular themes for your website.',
  displayed: true,
  htmlPageTitle: 'Top Themes',
  id: 'top-themes',
  metaDescription: 'There are thousands of themes, but these are the most downloaded. Try one of our most popular themes for your website.',
  name: 'top',
  slug: 'top-themes',
  title: 'Top Themes',
  query: new ThemeQuery({
    [ThemeQueryField.MIN_REVIEW_COUNT]: 3,
    [ThemeQueryField.SORT_FIELDS]: [ThemeSort.INSTALL_COUNT_DESC]
  })
};
const FREE = {
  description: 'Pick from dozens of themes to customize your website without stretching your budget.',
  displayed: true,
  htmlPageTitle: 'Best Free Themes',
  id: 'free-themes',
  metaDescription: 'Pick from dozens of themes to customize your website without stretching your budget.',
  name: 'free',
  slug: 'best-free-themes',
  title: 'Best Free Themes',
  query: new ThemeQuery({
    [ThemeQueryField.PLAN_TYPE]: PlanType.FREE
  })
};
const MOST_POPULAR_PAID = {
  description: 'They’re the best-selling themes for a reason. Try one of the most downloaded paid themes for your website.',
  displayed: true,
  htmlPageTitle: 'Most Popular Paid Themes',
  id: 'most-popular-paid-themes',
  metaDescription: 'They’re the best-selling themes for a reason. Try one of the most downloaded paid themes for your website.',
  name: 'mostPopularPaid',
  slug: 'most-popular-paid-themes',
  title: 'Most Popular Paid Themes',
  query: new ThemeQuery({
    [ThemeQueryField.PLAN_TYPE]: PlanType.ONE_TIME,
    [ThemeQueryField.SORT_FIELDS]: [ThemeSort.INSTALL_COUNT_DESC]
  })
};
const NEW = {
  description: 'Freshen up your website with some of the latest themes and templates.',
  displayed: true,
  htmlPageTitle: 'New Themes',
  id: 'new-themes',
  metaDescription: 'Freshen up your website with some of the latest themes and templates.',
  name: 'new',
  slug: 'new-themes',
  title: 'New Themes',
  query: new ThemeQuery({
    [ThemeQueryField.SORT_FIELDS]: [ThemeSort.NEWEST]
  })
};
const CMS_FREE = {
  displayed: true,
  description: 'Select from a variety of free website themes crafted by third-parties for our most popular use cases.',
  htmlPageTitle: 'Free CMS Website Themes',
  id: 'cms-free-themes',
  metaDescription: 'Select from a variety of free website themes crafted by third-parties for our most popular use cases.',
  name: 'freeCms',
  slug: 'free-cms-accelerator-themes',
  title: 'Free CMS Website Themes',
  query: new ThemeQuery({
    [ThemeQueryField.LIMIT]: 72,
    [ThemeQueryField.OFFERING_IDS]: () => {
      if (isQa()) {
        /* Random themes in order to test changes */
        return [966042, 1341577, 899166];
      }

      return [542211, 542213, 541226, 541223, 541218, 539201, 539200, 542206, 548202, 542199, 542198, 542202, 557225, 557226, 543212, 547205, 557200, 557199, 557203, 557204, 553219, 553217, 559206, 557229, 557222, 557215, 557205, 557198, 557207, 550208, 559214, 557218, 557220, 559255, 559252, 557209, 551201, 557213, 558199, 560201, 561248, 561235, 557208, 561208, 561209, 562225, 562243, 562220, 562241, 562231, 562205, 562239, 562219, 560199, 560200, 562211, 561199, 562232, 562229, 562244, 559223, 562246, 563227, 563230, 563226, 564200, 564213, 563212, 563220, 563231, 563221, 563225, 563229, 563228, 563216, 563203, 563207, 564238, 564239, 563247, 563279, 564214, 564206, 563224, 563280, 564237, 564245, 563235, 564256, 564212, 563238, 564305, 564242, 564204, 564203, 563285, 563219, 563214, 563215, 564248, 564244, 562247];
    }
  })
};
const initialState = {
  list: [CMS_FREE, TOP, FREE, MOST_POPULAR_PAID, NEW],
  requestState: RequestStates.UNINITIALIZED
};
export default initialState;